<template>
  <div
    id="app"
    :class="{ shrinkHeader: shrinkHeader, showNavPanel: showNavPanel, pinNavPanel: reallyPinNavPanel }"
  >
    <div
      id="main"
      @scroll="onScroll"
    >
      <GoogleAnalytics
        v-if="ga_id !== ''"
        :ga_id="ga_id"
      />
      <StandardHeader />
      <router-view />
      <StandardFooter v-if="showFooter" />
    </div>
    <Dialogs />
    <div
      id="mainCover"
      @click="handleMainCoverClick"
    />
    <StandardNavPanel />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import * as types from './store/mutation-types'

import GoogleAnalytics from './components/GoogleAnalytics'
import StandardHeader from './components/StandardHeader'
import StandardNavPanel from './components/StandardNavPanel'
import StandardFooter from './components/StandardFooter'
import Clipboard from 'clipboard'
import Dialogs from './components/dialogs/Dialogs'

export default {
  name: 'App',
  components: {
    GoogleAnalytics,
    StandardHeader,
    StandardNavPanel,
    StandardFooter,
    Dialogs,
  },
  computed: {
    ...mapState({
      shrinkHeader: state => state.appFrame.shrinkHeader,
      showNavPanel: state => state.appFrame.showNavPanel,
      showFooter: state => state.appFrame.showFooter,
      pinNavPanel: state => state.appFrame.pinNavPanel,
      windowWidth: state => state.appFrame.windowWidth,
      ga_id: state => state.status.ga_id,
    }),
    ...mapGetters(['getWindow']),
    reallyPinNavPanel: function () {
      let routeAllowsPin = true
      if (Object.prototype.hasOwnProperty.call(this.$route.meta, 'allowsNavPin')) {
        routeAllowsPin = this.$route.meta.allowsNavPin
      }
      return routeAllowsPin && this.pinNavPanel && this.windowWidth > 1023
    },
  },
  created: function () {
    this.getWindow.addEventListener('resize', this.onResize)
    this.$store.commit(types.SET_WINDOW_SIZE, { width: this.getWindow.innerWidth, height: this.getWindow.innerHeight })
    this.$store.commit(types.SET_PATH, { location: this.getWindow.location.pathname })

    /* eslint-disable no-new */
    new Clipboard('.copyButton')
  },
  methods: {
    handleMainCoverClick: function () {
      this.$store.commit(types.SET_SHOW_NAV_PANEL, false)
    },
    onScroll: function (event) {
      this.$store.commit(types.SET_WINDOW_SCROLL_POS, { left: event.target.scrollLeft, top: event.target.scrollTop })
    },
    onResize: function (event) {
      this.$store.commit(types.SET_WINDOW_SIZE, { width: event.target.innerWidth, height: event.target.innerHeight })
    },
  },
}

</script>

<style lang="scss">
  $imagePath: "~rs-styles/images";
  $fontPath: "~rs-styles/fonts";
  @import '~rs-styles/projects/package-manager/sass/package-manager.scss';
</style>
